/**
 * コメント候補テンプレート保存 API を提供する。
 * 管理シートのドラフトを DB に反映する。
 */

import type { RunToDatabase } from '@/types'
import { UnwritableDatabaseException } from '@pkg/basic'
import { saveCommentCandidates } from '@pkg/database-portfolio'
import type { InsertCommentCandidateData } from '@pkg/database-portfolio'

/**
 * コメント候補テンプレート一覧を保存する。
 * @param params DB 書き込み関数と保存対象一覧を受け取る。
 * @returns 値は返さない。
 */
export const saveHistoryCommentCandidates = async ({
  candidates,
  writeToDatabase,
}: {
  readonly writeToDatabase: RunToDatabase | undefined
  readonly candidates: readonly InsertCommentCandidateData[]
}): Promise<void> => {
  if (writeToDatabase === undefined) {
    throw new UnwritableDatabaseException()
  }

  await writeToDatabase((database) =>
    saveCommentCandidates({ database, candidates }),
  )
}
